/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Book_OptionalInputs */

const en_guest_book_optional = /** @type {(inputs: Guest_Book_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`optional`)
};

const pl_guest_book_optional = /** @type {(inputs: Guest_Book_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`opcjonalnie`)
};

/**
* | output |
* | --- |
* | "optional" |
*
* @param {Guest_Book_OptionalInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_optional = /** @type {((inputs?: Guest_Book_OptionalInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_OptionalInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_optional(inputs)
	return en_guest_book_optional(inputs)
});